import { useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import ProductListingPage from "../../../../../../components/ProductListingPage";
import ProductListSkeleton from "../../../../../../components/Results/ProductListSkeleton";
import { CHROME_BREADCRUMB_ID } from "../../../../../../components/constants";
import {
  useBreadcrumbUpdates,
  usePageAnalyticsUpdates,
} from "../../../../../../components/hooks";
import { useUpdateRefineParameters } from "../../../../../../components/hooks/useUpdateRefineParameters";
import {
  getItemCount,
  hasFacets,
  getPaginationData,
  getSearchTerm,
} from "../../../../../../state/modules/search";
import { getError } from "../../../../../../state/modules/error";
import { getIsLoading } from "../../../../../../state/modules/page/selectors";

const EMPTY_BREADCRUMBS = [];

export const SearchPage = ({
  formatTranslation,
  location,
  topContent = null,
}) => {
  const hasFacetsValue = useSelector(hasFacets);
  const itemCount = useSelector(getItemCount);
  const isLoading = useSelector(getIsLoading);
  const paginationData = useSelector(getPaginationData);
  const searchTerm = useSelector(getSearchTerm);
  const error = useSelector(getError);

  const page = paginationData?.page;

  useBreadcrumbUpdates(EMPTY_BREADCRUMBS);

  usePageAnalyticsUpdates();

  useUpdateRefineParameters({ searchTerm });

  useEffect(() => {
    if (searchTerm && page) {
      const { initial, max } = page;

      document.title = formatTranslation("plp_web_search_page_title", {
        searchTerm,
        currentPage: initial,
        maxPage: max,
      });
    }
  }, [searchTerm, page, formatTranslation]);

  useEffect(() => {
    if (typeof document === "undefined") {
      return undefined;
    }

    const breadcrumbElement = document.getElementById(CHROME_BREADCRUMB_ID);

    if (!breadcrumbElement) {
      return undefined;
    }

    const previousDisplay = breadcrumbElement.style.display;

    breadcrumbElement.style.display = "none";

    return () => {
      breadcrumbElement.style.display = previousDisplay;
    };
  }, []);

  if (isLoading) {
    return <ProductListSkeleton />;
  }

  return (
    <ProductListingPage
      hasFacets={hasFacetsValue}
      itemCount={itemCount}
      paginationData={paginationData}
      error={error}
      searchTerm={searchTerm}
      location={location}
      topContent={topContent}
    />
  );
};

SearchPage.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  location: PropTypes.object,
  topContent: PropTypes.node,
};

export default SearchPage;
